import React from 'react';
import { Container, Row, Col, Card, Button, CardBody, CardText, Label, FormGroup, Modal, ModalHeader, ModalBody } from 'reactstrap'
import Header from '../../Componentes/header'
import Footer from '../../Componentes/footer'
import '../../CSS/bootstrap.min.css'
import '../../CSS/style.css'
import Nav from './Componentes/aspiranteNav'
import Fetch from '../../Auxiliares/fetch'
import { toast } from 'react-toastify'
import ReactFileReader from 'react-file-reader'
import documentImg from '../../Img/Iconos/document.png'
import moment from 'moment'
import Banner from '../../Img/Banner.png'

export default class AspiranteInicio extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            documentos: [],
            referencias: [],
            estado: 0,
            file: null,
            icon: '',
            buttonShow: false,
            isModalOpen: null,
            activarRevision: true,
            usuarioAsignado: '',
            objectoRevision: {},
            activarGuardar: true,
            activarEnviar: true,
            etapas: [],
            mostrarMensaje: false,
        }

        this.referenciar = this.referenciar.bind(this)
        this.subirDocumento = this.subirDocumento.bind(this)
        this.getPerfil = this.getPerfil.bind(this)
        this.actualizarEstado = this.actualizarEstado.bind(this)
        // this.revision = this.revision.bind(this)
        // this.permitirRevision = this.permitirRevision.bind(this)
        // this.revisionEstados = this.revisionEstados.bind(this)
        this.guardar = this.guardar.bind(this)
        // this.Evento = this.Evento.bind(this)
        this.setDocumentos = this.setDocumentos.bind(this)
        this.tituloDocumento = this.tituloDocumento.bind(this)
    }

    componentDidMount() {
        this.getPerfil()
    }

    guardar(data) {
        this.setState({ activarGuardar: false })
        this.subirDocumento(data)
        this.toggleModal()
    }

    toggleModal(index) {
        this.setState({ isModalOpen: index >= 0 ? index : null, file: null, icon: false, activarGuardar: true })
        this.getPerfil()
    }

    setDocumentos(etapas) {
        var flag = 0;
        var date = moment().format();

        etapas.forEach((element, index) => {
            if (moment(date).isBetween(element.fecha_inicio.split("T")[0], element.fecha_final.split("T")[0])) {
                flag = 1;
            }
        })
        
        etapas.forEach((element, index) => {

            if (moment(date).isBetween(element.fecha_inicio.split("T")[0], element.fecha_final.split("T")[0])) {
                flag = 1;
                this.setState({documentos: element.documentos })
                //segundaEtapaEnAdelante
                if(index == 1) this.setState({mostrarMensaje: true});

                Fetch('/api/getAspirantePerfil', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ curp: sessionStorage.getItem('curp') })
                })
                    .then(response => {
                        this.referenciar(response.data)
                    })
                    .catch(err => {
                        switch (err.status) {
                            case 600:
                                toast.error('Datos no encontrados')
                                break;

                            case 605:
                                toast.info('No existen coincidencias')
                                break;

                            default:
                                toast.error("Se produjo un error de conexion " + err)
                                break;
                        }
                    })
            }
            if (flag == 0){
                Fetch('/api/getAspirantePerfilRechazados', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ curp: sessionStorage.getItem('curp') })
                })
                    .then(response => {
                        this.setState({documentos: response.docs, referencias: response.ref})

                    })
                    .catch(err => {
                        switch (err.status) {
                            case 600:
                                toast.error('Datos no encontrados')
                                break;
    
                            case 605:
                                toast.info('No existen coincidencias')
                                break;
    
                            default:
                                toast.error("Se produjo un error de conexion " + err)
                                break;
                        }
                    })
            }
        });
        /*if(!this.state.documentos.length){
        }*/
    }

    getPerfil() {

        Fetch('/getEtapasAspirante', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' }
        })
            .then(response => {
                this.setDocumentos(response.data)
            })
            .catch(err => {
                switch (err.status) {
                    case 600:
                        toast.error('Datos no encontrados')
                        break;

                    default:
                        toast.error("Se produjo un error de conexion " + err)
                        break;
                }
            })

        Fetch('/api/getUsuarioAsignado', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ ficha: sessionStorage.getItem('ficha') })
        })
            .then(response => {
                this.setState({ usuarioAsignado: response.data })
            })
            .catch(err => {
                switch (err.status) {
                    case 600:
                        toast.error('Datos no encontrados' + err)
                        break;

                    case 605:
                        toast.info('No existen coincidencias')
                        break;

                    default:
                        toast.error("Se produjo un error de conexion " + err)
                        break;
                }
            })
    }

    handleFile = (file) => {
        this.setState({ file: [file.base64], icon: <FormGroup><img src={documentImg} alt="documento imagen" width={50} /></FormGroup>, activarGuardar: false })
    }

    referenciar(perfil) {
        var ref = []

        this.state.documentos.forEach(elem => {
            ref.push(perfil[elem])
        })

        if(ref["forma_extranjero"]){
            if(sessionStorage.getItem("nacionalidad") != "E"){
                delete ref["forma_extranjero"];
            }
        }

        this.setState({ referencias: ref })
        if (this.state.referencias) this.setState({ buttonShow: true })
    }

    actualizarEstado() {
        this.setState({ file: null, icon: false })
        toast.success('Documento enviado!')
    }

    evaluarPerfil(){
        const correo = this.state.usuarioAsignado;
        const ficha = sessionStorage.getItem('ficha')
        const nombre = sessionStorage.getItem('nombre') + " " + sessionStorage.getItem('ap_paterno') + " " + sessionStorage.getItem('ap_materno');
        
        if(this.state.referencias.length > 0){
            var count = 0;
            this.state.referencias.forEach(elem => {    
                if(elem.estado === 'RECHAZADO' || elem.estado === 'VACIO')count++
            });

            if(count){
                Fetch('/notificarRevisionPeticion', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ ficha, nombre, correo })
                })
                    .then(response => {
                        this.actualizarEstado()
                    })
                    .catch(err => {
                        switch (err.status) {
                            case 609:
                                toast.error('Error al registrar documento')
                                break;

                            default:
                                toast.error("Se produjo un error de conexion" + err)
                                break;
                        }
                    }) 
            }
        }
        
    }

    subirDocumento(elem) {

        if (this.state.file !== null) {
            const curp = sessionStorage.getItem('curp');
            const file = this.state.file[0];
            const referencias = this.state.referencias;
            const documentos = this.state.documentos;

            switch (elem) {
                case 'solicitud':
                    //solicitud
                    Fetch('/api/addSolicitudAP', {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({ curp, file, referencias, documentos })
                    })
                        .then(response => {
                            this.actualizarEstado()
                            //this.permitirRevision()
                            this.setState({ activarGuardar: true })
                            this.evaluarPerfil()
                        })
                        .catch(err => {
                            switch (err.status) {
                                case 400:
                                    toast.error('Error al registrar documento')
                                    break;

                                case 600:
                                    toast.error('Error generico' + err)
                                    break;

                                case 614:
                                    toast.error('Error al actualizar información')
                                    break;

                                default:
                                    toast.error("Se produjo un error de conexion" + err)
                                    break;
                            }
                        })
                    break;

                case 'acta_nacimiento':
                    //acta de nacimiento
                    Fetch('/api/addActaNacimientoAP', {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({ curp, file, referencias, documentos })
                    })
                        .then(response => {
                            this.actualizarEstado()
                            // this.permitirRevision()
                            this.setState({ activarGuardar: true })
                            this.evaluarPerfil()
                        })
                        .catch(err => {
                            switch (err.status) {
                                case 400:
                                    toast.error('Error al registrar documento')
                                    break;

                                case 600:
                                    toast.error('Error generico' + err)
                                    break;

                                case 614:
                                    toast.error('Error al actualizar información')
                                    break;

                                default:
                                    toast.error("Se produjo un error de conexion" + err)
                                    break;
                            }
                        })
                    break;

                case 'acta_curp':
                    //curp
                    Fetch('/api/addActaCurpAP', {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({ curp, file, referencias, documentos })
                    })
                        .then(response => {
                            this.actualizarEstado()
                            // this.permitirRevision()
                            this.setState({ activarGuardar: true })
                            this.evaluarPerfil()
                        })
                        .catch(err => {
                            switch (err.status) {
                                case 400:
                                    toast.error('Error al registrar documento')
                                    break;

                                case 600:
                                    toast.error('Error generico' + err)
                                    break;

                                case 614:
                                    toast.error('Error al actualizar información')
                                    break;

                                default:
                                    toast.error("Se produjo un error de conexion" + err)
                                    break;
                            }
                        })
                    break;

                case 'fotografia':
                    //fotografia
                    Fetch('/api/addFotografiaAP', {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({ curp, file, referencias, documentos })
                    })
                        .then(response => {
                            this.actualizarEstado()
                            // this.permitirRevision()
                            this.setState({ activarGuardar: true })
                            this.evaluarPerfil()
                        })
                        .catch(err => {
                            switch (err.status) {
                                case 400:
                                    toast.error('Error al registrar documento')
                                    break;

                                case 600:
                                    toast.error('Error generico' + err)
                                    break;

                                case 614:
                                    toast.error('Error al actualizar información')
                                    break;

                                default:
                                    toast.error("Se produjo un error de conexion" + err)
                                    break;
                            }
                        })
                    break;

                case 'documento_institucional':
                    //certificado de bachillerato
                    Fetch('/api/addDocumentoInstitucionalAP', {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({ curp, file, referencias, documentos })
                    })
                        .then(response => {
                            this.actualizarEstado()
                            // this.permitirRevision()
                            this.setState({ activarGuardar: true })
                            this.evaluarPerfil()
                        })
                        .catch(err => {
                            switch (err.status) {
                                case 400:
                                    toast.error('Error al registrar documento')
                                    break;

                                case 600:
                                    toast.error('Error generico' + err)
                                    break;

                                case 614:
                                    toast.error('Error al actualizar información')
                                    break;

                                default:
                                    toast.error("Se produjo un error de conexion" + err)
                                    break;
                            }
                        })
                    break;

                case 'forma_extranjero':
                    //forma extranjera
                    Fetch('/api/addFormaExtranjeroAP', {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({ curp, file, referencias, documentos })
                    })
                        .then(response => {
                            this.actualizarEstado()
                            // this.permitirRevision()
                            this.setState({ activarGuardar: true })
                            this.evaluarPerfil()
                        })
                        .catch(err => {
                            switch (err.status) {
                                case 400:
                                    toast.error('Error al registrar documento')
                                    break;

                                case 600:
                                    toast.error('Error generico' + err)
                                    break;

                                case 614:
                                    toast.error('Error al actualizar información')
                                    break;

                                default:
                                    toast.error("Se produjo un error de conexion" + err)
                                    break;
                            }
                        })
                    break;

                case 'contrato_estudiantil':
                    //contrato estudiantil
                    Fetch('/api/addContratoEstudiantilAP', {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({ curp, file, referencias, documentos })
                    })
                        .then(response => {
                            this.actualizarEstado()
                            // this.permitirRevision()
                            this.setState({ activarGuardar: true })
                            this.evaluarPerfil()
                        })
                        .catch(err => {
                            switch (err.status) {
                                case 400:
                                    toast.error('Error al registrar documento')
                                    break;

                                case 600:
                                    toast.error('Error generico' + err)
                                    break;

                                case 614:
                                    toast.error('Error al actualizar información')
                                    break;

                                default:
                                    toast.error("Se produjo un error de conexion" + err)
                                    break;
                            }
                        })
                    break;

                case 'nss':
                    //Numero de seguro social
                    Fetch('/api/addNssAP', {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({ curp, file, referencias, documentos })
                    })
                        .then(response => {
                            this.actualizarEstado()
                            // this.permitirRevision()
                            this.setState({ activarGuardar: true })
                            this.evaluarPerfil()
                        })
                        .catch(err => {
                            switch (err.status) {
                                case 400:
                                    toast.error('Error al registrar documento')
                                    break;

                                case 600:
                                    toast.error('Error generico' + err)
                                    break;

                                case 614:
                                    toast.error('Error al actualizar información')
                                    break;

                                default:
                                    toast.error("Se produjo un error de conexion" + err)
                                    break;
                            }
                        })
                    break;

                default:
                    break;
            }
        } else {
            toast.error('No se ha seleccionado ningun archivo')
        }
    }

    tituloDocumento(doc) {
        switch (doc) {
            case 'solicitud': return "Solicitud de inscripción"
            case 'acta_nacimiento': return "Acta de nacimiento"
            case 'acta_curp': return "CURP"
            case 'documento_institucional': return "Certificado de preparatoria (documento que valide su educación preparatoria)"
            case 'fotografia': return "Fotografía"
            case 'forma_extranjero': return "Forma Migratoria Múltiple (Documento necesario en caso de ser extranjero)"
            case 'contrato_estudiantil': return "Contrato estudiantil"
            case 'nss': return "Constancia de vigencia de derechos (IMSS)"
            default: return "ejemplo"
        }
    }

    render() {
        //console.log(this.state.documentos)
        return (
            <html>
                <Header />
                <Row>
                    <Col className="bg-light" lg="3">
                        <Nav nombre_completo={sessionStorage.getItem('nombre') + " " + sessionStorage.getItem('ap_paterno') + " " + sessionStorage.getItem('ap_materno')} />
                    </Col>

                    <Col className="bg-light" lg="9">
                        <div id="page-content-wrapper">
                            <div class="container-fluid">
                                <Container>
                                    <div className="row justify-content-center align-items-center my-1 mx-2">
                                        <Card className="my-5 w-100 h-100 text-center">
                                            <div className="p-5 text-left">
                                                <Container>
                                                    <Card className="text-center justify-content-center border-light">
                                                        <CardBody>
                                                            <Row>
                                                                <p className="text-justify" >
                                                                    Hola, bienvenid{sessionStorage.getItem('sexo') === 'F' ? 'a' : 'o'} futuro búfalo del Instituto Tecnológico de Mexicali.
                                                                </p>

                                                                <p className="text-justify">
                                                                    El aspirante escaneara cada uno de los documentos enlistados a continuación, con el fin de tenerlos listos en formato PDF. Dichos documentos deberán mantenerlos en resguardo hasta la fecha en que deba presentarlos según lo indicado la convocatoria, por lo que te invitamos a leer con mucho detalle cada paso de la convocatoria y comprenderlos.
                                                                </p>

                                                                {this.state.usuarioAsignado !== '' ? (
                                                                    <p className="font-italic text-justify p-3" style={{ backgroundColor: '#a8b5ff', fontSize: "14px" }}>
                                                                        Si tienes alguna duda con respecto a algún documento, puedes comunicarte vía correo electrónico con tu revisor asignado: <div className="d-inline-block font-weight-bold">{this.state.usuarioAsignado}</div> en dias hábiles (Lunes a Viernes) en un horario de 8:30 AM a 2:30 PM en caso de que te haya tocado una revisora o bien de 1:30 PM a 7:30 PM en caso de que te haya tocado un revisor.
                                                                    </p>) : ''}
                                                                <br />
                                                            </Row>

                                                            <Row>
                                                                <Col className="text-center mb-3 mt-3">
                                                                    Código de Color de Estados
                                                                            </Col>
                                                            </Row>

                                                            <Row className="text-center text-white">
                                                                <Col xs="12" md="6" xl="3" className="bg-secondary d-flex justify-content-center"><div className="py-2">Vacio</div></Col>
                                                                <Col xs="12" md="6" xl="3" className="bg-warning d-flex justify-content-center"><div className="py-2">Revisión</div></Col>
                                                                <Col xs="12" md="6" xl="3" className="bg-success d-flex justify-content-center"><div className="py-2">Aceptado</div></Col>
                                                                <Col xs="12" md="6" xl="3" className="bg-danger d-flex justify-content-center"><div className="py-2">Rechazado</div></Col>

                                                            </Row>
                                                        </CardBody>
                                                    </Card>

                                                    <Row className="mt-3">
                                                        {this.state.documentos.length > 0 ? this.state.documentos.map((value, index) => (
                                                            ((sessionStorage.getItem('nacionalidad') === 'E') && (value == "forma_extranjero") || (value != "forma_extranjero")) ? (
                                                                <Col xs="12" md="6" xl="4" className="my-1">
                                                                    <Card className="w-100 bg-secondary" style={{ height: '12rem' }} onClick={() => this.toggleModal(index)}>
                                                                        <CardBody style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }} className={this.state.referencias.length > 0 ? this.state.referencias[index].estado === 'REVISION' ? "text-center btn bg-warning" : this.state.referencias[index].estado === 'RECHAZADO' ? "text-center btn bg-danger" : this.state.referencias[index].estado === 'ACEPTADO' ? "text-center btn bg-success" : "text-center btn" : "" } >
                                                                            <CardText className="font-weight-bold justify-content-center text-light" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', margin: 'auto' }}>
                                                                                {this.tituloDocumento(value)}
                                                                            </CardText>

                                                                        </CardBody>
                                                                    </Card>
                                                                </Col>) : ""
                                                        )) : <div></div>}
                                                    </Row>

                                                </Container>

                                                <Modal isOpen={this.state.isModalOpen !== null} toggle={() => this.toggleModal()}
                                                    className="modal-lg">
                                                    <ModalHeader
                                                        style={{
                                                            background: `url(${Banner}) center`,
                                                            backgroundSize: 'cover', backgroundPosition: 'center-left',
                                                        }}
                                                        toggle={() => this.toggleModal()}><h5 className="text-light">{this.state.isModalOpen !== null ? this.tituloDocumento(this.state.documentos[this.state.isModalOpen]) : ''}</h5></ModalHeader>
                                                    <ModalBody>
                                                        <Row>
                                                            <Col>
                                                                <Row>
                                                                    {this.state.isModalOpen !== null ?
                                                                        <Container>
                                                                            <Row>
                                                                                <Col className="col-6 text-center mx-auto">
                                                                                    <Card className="p-5 border-0">
                                                                                        {this.state.referencias[this.state.isModalOpen].estado === 'ACEPTADO'
                                                                                            ? <div style={{ height: '5rem' }} className="p-4 font-weight-bold">{this.state.referencias[this.state.isModalOpen].estado === 'ACEPTADO' ? 'Documento aceptado!' : ""}</div>
                                                                                            : this.state.referencias[this.state.isModalOpen].estado === 'REVISION' ? 
                                                                                            <Card className="border-0 p-3"><Label>{this.tituloDocumento(this.state.documentos[this.state.isModalOpen])}</Label>{this.state.icon}<FormGroup className="mt-3"><Col className="text-danger font-weight-bold mb-4">{this.tituloDocumento(this.state.documentos[this.state.isModalOpen])==='Certificado de bachillerato (documento que valide su educación preparatoria)' && this.state.mostrarMensaje ? "En esta etapa este documento deberá ser una Carta Compromiso o un Certificado de Preparatoria" : ""}</Col><ReactFileReader fileTypes={this.state.documentos[this.state.isModalOpen] === "fotografia" ? [".jpg", ".jpeg", ".png"] : [".pdf"]} base64={true} multipleFiles={false} handleFiles={this.handleFile} ><button className='btn btn-primary'>Seleccionar documento</button></ReactFileReader></FormGroup><FormGroup className="text-center"><Button className="bg-success col-6" disabled={this.state.activarGuardar} onClick={() => this.guardar(this.state.documentos[this.state.isModalOpen])}>Guardar</Button></FormGroup></Card> : 
                                                                                            <Card className="border-0 p-3"><Label>{this.tituloDocumento(this.state.documentos[this.state.isModalOpen])}</Label>{this.state.icon}<FormGroup className="mt-3"><Col className="text-danger font-weight-bold mb-4">{this.tituloDocumento(this.state.documentos[this.state.isModalOpen])==='Certificado de bachillerato (documento que valide su educación preparatoria)' && this.state.mostrarMensaje ? "En esta etapa este documento deberá ser una Carta Compromiso o un Certificado de Preparatoria" : ""}</Col><ReactFileReader fileTypes={this.state.documentos[this.state.isModalOpen] === "fotografia" ? [".jpg", ".jpeg", ".png"] : [".pdf"]} base64={true} multipleFiles={false} handleFiles={this.handleFile} ><button className='btn btn-primary'>Seleccionar documento</button></ReactFileReader></FormGroup><FormGroup className="text-center"><Button className="bg-success col-6" disabled={this.state.activarGuardar} onClick={() => this.guardar(this.state.documentos[this.state.isModalOpen])}>Guardar</Button></FormGroup></Card>}
                                                                                    </Card>
                                                                                </Col>
                                                                            </Row>
                                                                        </Container>
                                                                        : ''}
                                                                </Row>
                                                            </Col>
                                                        </Row>
                                                    </ModalBody>
                                                </Modal>
                                            </div>
                                        </Card>
                                    </div>
                                </Container>
                            </div>
                        </div>
                    </Col>

                </Row>
                <Footer />
            </html >
        )
    }
}
